// jsPDF/html2canvas are only needed when a Share button is actually
// clicked (a handful of admin/print pages) -- dynamic imports keep them out
// of the main bundle so they don't slow down every page's initial load,
// including the public site.

// Renders a DOM element to a PDF Blob so it can be attached as a real file
// when sharing, rather than only sharing a link the recipient has to open
// separately. The page is a single A4-width sheet sized to exactly fit the
// content's height -- these documents are read on screen (WhatsApp, email),
// not bound as physical multi-page printouts, so there's no page break to
// slice a table row or box in half.
export async function generatePdfBlob(element) {
  const [{ default: jsPDF }, { default: html2canvas }] = await Promise.all([
    import(/* webpackChunkName: "pdf-export" */ 'jspdf'),
    import(/* webpackChunkName: "pdf-export" */ 'html2canvas')
  ])

  // Force capture at a desktop-width virtual viewport. Without this, a PDF
  // generated from a phone picks up the same sm: mobile-responsive layout
  // (stacked, single-column) meant for on-screen viewing there, instead of
  // the polished desktop layout -- so the exported document looks cramped
  // no matter how good it looks on screen. windowWidth makes html2canvas
  // evaluate all CSS media queries as if the browser were 1280px wide,
  // regardless of the device that's actually generating the file.
  const canvas = await html2canvas(element, {
    scale: 2,
    useCORS: true,
    backgroundColor: '#ffffff',
    windowWidth: 1280,
    windowHeight: element.scrollHeight
  })
  const imgData = canvas.toDataURL('image/jpeg', 0.92)

  const pageWidth = 210 // A4 width, mm
  const imgWidth = pageWidth
  const imgHeight = (canvas.height * imgWidth) / canvas.width

  const pdf = new jsPDF({ unit: 'mm', format: [pageWidth, imgHeight] })
  pdf.addImage(imgData, 'JPEG', 0, 0, imgWidth, imgHeight)

  return pdf.output('blob')
}
